(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retreat-room-cards"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-room-slider]').forEach(function (slider) {
  var track = slider.querySelector('[data-room-track]');
  var slides = track.children;
  var dotsBox = slider.querySelector('[data-room-dots]');
  if (slides.length < 2) {
    slider.querySelectorAll('.room-card__arrow').forEach(function (b) { b.hidden = true; });
    return;
  }
  var dots = [];
  for (var i = 0; i < slides.length; i++) {
    var d = document.createElement('span');
    if (i === 0) d.className = 'is-active';
    dotsBox.appendChild(d);
    dots.push(d);
  }
  function index() {
    return Math.round(track.scrollLeft / track.clientWidth);
  }
  function updateDots() {
    var i = index();
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
  }
  function animateTo(left) {
    if (document.hidden) {
      track.scrollLeft = left;
      updateDots();
      return;
    }
    var start = track.scrollLeft;
    var dist = left - start;
    var t0 = null;
    track.style.scrollSnapType = 'none';
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / 300, 1);
      var e = 1 - Math.pow(1 - p, 3);
      track.scrollLeft = start + dist * e;
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        track.style.scrollSnapType = '';
        updateDots();
      }
    }
    requestAnimationFrame(step);
  }
  function go(delta) {
    var next = (index() + delta + slides.length) % slides.length;
    animateTo(next * track.clientWidth);
  }
  slider.querySelector('[data-room-prev]').addEventListener('click', function () { go(-1); });
  slider.querySelector('[data-room-next]').addEventListener('click', function () { go(1); });
  track.addEventListener('scroll', updateDots, { passive: true });
});

  } catch(e) { console.error(e); }
})();
})();
